import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetRespondentDetailsRPC } from "./getRespondentDetailsRPC";

export class GetRespondentDetailsRPCClientImpl extends GetRespondentDetailsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetRespondentDetailsRPC.Request): Promise<LeoRPCResult<GetRespondentDetailsRPC.Response, GetRespondentDetailsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "respondent/GetRespondentDetails",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetRespondentDetailsRPC.ResponseDTO,
      GetRespondentDetailsRPC.Errors.ErrorsDTO,
      GetRespondentDetailsRPC.Response,
      GetRespondentDetailsRPC.Errors.Errors
    >(
      response,
      "respondent/GetRespondentDetails",
      GetRespondentDetailsRPC.Response.fromDTO,
      GetRespondentDetailsRPC.Errors.fromDTO
    );
  }
}
